module.exports = __webpack_public_path__ + "media/images/emblems/Lully-coat_of_arms-0aa85390de802f3b9c366c937f440289.svg";